<template>
  <div v-if="loaded">
    <transition-group name="flip-list" tag="el-container">
      <!-- <el-container> -->
      <el-aside :width="leftWidth" style="background-color: #095b69" ref="leftPanel" key="lp">
        <!-- <h4 class="dark">Working period</h4> -->

        <div style="padding:5px;">
          <s-dater range v-model="sfuelsWorkingRange" displayFormat="dd/MM/yyyy"></s-dater>
        </div>
        <el-menu
          background-color="#545c64"
          text-color="#fff"
          router
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="/fuels/vehicles">
            <i class="material-icons">directions_bus</i>
            <span>Vehicles Sapplies</span>
          </el-menu-item>
          <el-menu-item index="/fuels/tanks">
            <i class="material-icons">ev_station</i>
            <span>Tank Sapplies</span>
          </el-menu-item>
          <el-menu-item index="/fuels/fuelsrs">
            <i class="material-icons">store</i>
            <span>Fuel Sources</span>
          </el-menu-item>
        </el-menu>
        <br />
        <el-card>
          <h4>Tanks</h4>

          <el-row  class="line-view"
            v-for="load in fuelReadings.loads"
            :key="load.id+load.srcName"
            v-if="load.srcName"
          >
            <el-col :span="8">{{load.srcName}}</el-col>
            <el-col :span="16" style="text-align:right;">{{formatNumber(load.srcLoad) }}</el-col>
          </el-row>
          <el-divider></el-divider>
          <h4>Pumps</h4>

          <el-row v-for="pump in fuelReadings.pumps" :key="pump.id+pump.pump" v-if="pump.srcName" class="line-view">
            <el-col :span="10">{{pump.srcName}}</el-col>
            <el-col :span="4">
              <el-button type="warning" @click="fixPump(pump.id,pump.pump)">{{pump.pump}}</el-button>
            </el-col>
            <el-col :span="10" style="text-align:right;">{{formatNumber(-(pump.spumpreading)) }}</el-col>
          </el-row>
        </el-card>
      </el-aside>
      <el-container key="rp">
        <el-row style="width:100%" :key="reloadClock">
          <router-view></router-view>
        </el-row>
      </el-container>
    </transition-group>
    <!-- </el-container> -->
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

export default {
  data() {
    return {
      sfuelsWorkingRange: null,
      loaded: false,
      leftWidth: "280px",
      reloadClock: 0
    };
  },
  watch: {
    sfuelsWorkingRange(val) {
      this.setFuelsWorkingRange(val);
    }
  },
  computed: {
    fuelReadings() {
      var x = this.getList("readings");
      _log_("n....", x);
      return x;
    },
    ...mapGetters({
      getList: "tags/getList",
      updateTick: "tags/updateTick",
      fuelsWorkingRange: "user/fuelsWorkingRange"
    })
  },
  methods: {
    async fixPump(tankid, pump) {
      const { data } = await api.fetchProcessor("fuels/readings", {
        fuel_src_id: tankid,
        pump: pump,
        do: "fixpump"
      });
      ++this.reloadClock;
      _log_("fixed..", data);
    },
    ...mapActions({
      fetchAllOptions: "tags/fetchAll"
    }),
    ...mapMutations({ setFuelsWorkingRange: "user/setFuelsWorkingRange" }),

    // setWorkingState(key, keyPath) {
    //   this.vehicleSapply = key;
    //   _log_(key, keyPath);
    // },
    // handleClose(key, keyPath) {
    //   _log_(key, keyPath);
    // },
    // ...mapActions({
    //   fetchAllOptions: "tags/fetchAll"
    // }),
    // removeFuelTransaction(e) {
    //   _log_("hell.RRs..", e);
    // },
    // async handleFuelTransaction(e) {
    //   const data = await api.updateProcessor("fuels/update", e.row);
    //   // _log_("upd...", data);
    //   if (data) this.updateArrayElement(this.fuelTrans, data, "id", true);
    // },
    // async goPrintThis() {
    //   // var { data } = await api.fetchProcessor("bookings/vuebookings", {
    //   //   "bookingRange[]": this.bookingRange,
    //   //   idHotel: this.activeHotel,
    //   //   searchall: this.searchall,
    //   //   limit: 0
    //   // });
    //   // this.printData = data.results;
    //   this.loaded = true;
    // },
    alert(msg) {
      _log_("hell...", msg, this.bookingRangeA.getTime());
    }
  },
  async mounted() {
    const date = new Date(),
      vm = this;
    await this.fetchAllOptions();
    // var { data } = await api.fetchProcessor("bookings/vuebookings", {
    //   "bookingRange[]": this.bookingRange,
    //   idHotel: this.activeHotel,
    //   searchall: this.searchall,
    //   dailyView: true,
    //   limit: 0
    // });
    // this.todayDepartures = data.results.departures
    //   ? data.results.departures
    //   : [];
    // this.todayArrivals = data.results.arrivals ? data.results.arrivals : [];
    this.loaded = true;
    $(".panel_btn").unbind();
    $(".panel_btn").attr("onclick", "");
    $(".panel_btn").click(function() {
      if (vm.leftWidth == "280px") vm.leftWidth = "0px";
      else vm.leftWidth = "280px";
      // _log_("vvvv,", app, vm.$refs);
    });
  }
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}
.has-more {
  color: red;
  font-weight: 700;
}
.flip-list-move {
  transition: transform 1s;
}
</style>
